import React, { FunctionComponent, SyntheticEvent } from 'react';

import SOCIAL from '../../constants/social';
import isMobile from '../../utils/isMobile';
import { withTrack, WithTrack } from '../../utils/analytics';
import { captureException } from '@sentry/browser';
import { useShareContext } from '../../context/ShareContext';
import { usePageMeta } from '../../hooks';
import { LinkButton } from './LinkButton';

// TODO social_utm_term on all social tracking? campaign does it?

export type MessengerShareProps = WithTrack & {
  className?: string;
  trackingData: Record<string, any>;
};

export const MessengerShare: FunctionComponent<MessengerShareProps> = ({
  className,
  track,
  trackingData,
}) => {
  const { shareItems } = useShareContext();
  const { isPreview } = usePageMeta();

  const onClick = (event: SyntheticEvent) => {
    track(trackingData);

    if (!isMobile(window)) {
      event.preventDefault();
      FB.ui(
        {
          method: 'send',
          link: shareItems.facebookMessenger.url,
        },
        response => {
          if (response.error_message || response.error_code) {
            captureException({
              facebookErrorCode: response.error_code,
              facebookErrorMessage: response.error_message,
            });
          }
        },
      );
    }
  };

  const as = !isPreview ? 'a' : 'div';
  const href = !isPreview
    ? `fb-messenger://share/?link=${shareItems.facebookMessenger.url}&app_id=${SOCIAL.FB_APP_ID}`
    : undefined;
  const handleClick = !isPreview ? onClick : undefined;
  return (
    <LinkButton
      as={as}
      dataQa="messenger-btn"
      href={href}
      onClick={handleClick}
      className={`jg-btn jg-btn--messenger ${className}`}
    >
      Messenger
    </LinkButton>
  );
};

export default withTrack(MessengerShare);
